// extracted by mini-css-extract-plugin
export default {"controlsContainer":"f679462666","controls":"b651e96f9b _0c93f51496 _1232bef568 c0c84bde2b","segment":"edbd435e1f _50d935d57a d28fc46944","active":"_634f44cefd","ready":"f3ff053bcb"};